import { AfterViewChecked, AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ContentService } from 'src/app/core/services/content.service';
import { AudioPlaylistComponent } from '../audio-playlist/audio-playlist.component';
import * as $ from 'jquery';
import { PlayContentService } from 'src/app/core/services/play-content.service';
import { SubCategoryService } from 'src/app/core/services/sub-category.service';
import { NgClass } from '@angular/common';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { QueueListDatePipe } from '../../pipes/queue-list-date.pipe';
import { QueueListDurationPipe } from '../../pipes/queue-list-duration.pipe';
import { UikitService } from 'src/app/core/services/uikit.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { ModelPaymentComponent } from '../model-payment/model-payment.component';
import { MainAccountModule } from 'src/app/modules/account/main-account/main-account.module';
import { ChangePlanComponent } from 'src/app/modules/account/main-account/model-screens/change-plan/change-plan.component';
import { SigninPopupComponent } from '../signin-popup/signin-popup.component';
import { WishlistService } from 'src/app/core/services/wishlist.service';
import { RoundProgressComponent } from 'angular-svg-round-progressbar';
import { HomeService } from 'src/app/core/services/home.service';
import { lastValueFrom } from 'rxjs';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-audio-podcast',
  standalone: true,
  imports: [AudioPlaylistComponent, NgClass, QueueListDatePipe,QueueListDurationPipe, ModelPaymentComponent, MainAccountModule, SigninPopupComponent, RoundProgressComponent],
  templateUrl: './audio-podcast.component.html',
  styleUrl: './audio-podcast.component.scss',
})
export class AudioPodcastComponent implements OnInit, OnChanges, AfterViewInit, AfterViewChecked {
  @Input() data;
  @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;
  @ViewChild('progressBarContainer') progressBarContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('progressBar') progressBar!: ElementRef<HTMLDivElement>;
  @ViewChild('audioPodcastMobileContainer') mobileAudioPodcastContainer:ElementRef<HTMLDivElement>;
  wishListData = [];
  seekbarBaseColor: string;
  seekbarProgressColor: string;
  currentPlayingContentUrl = "";
  currentPlayingContentAvailability;
  currentPlayingContentGeoAvailability:number = 1;
  showPlayer = false;
  currentContentPersona;
  currentContentAssetData:{title:string, cast:string, poster_square:string, genre:Array<any>, content_id, is_audio, is_series,description, wishlist_status:boolean};
  mobScreenCurrentEpisodeTitle:string;
  currentPlayingEpisode;
  currentProgressPercentage;
  isPlaying = false;
  position;
  guest;
  currentCollection;
  playlistContent =[];
  queueList= [];
  shuffle=false;
  audioRepeat = false;
  genreCurationEnabled;
  episodesList = [];
  currentSelectedType='';
  queueListOpen = false;
  guestSubscribe;
  selectedContentTypeSubscribe;
  currentContentCollectionSubscribe;
  currentPlayingTime;
  totalPlayingTime;
  personaApiFail = false;
  audioCollectionApiFail = false;
  windowWidth;
  showMobScreen = false;
  showPodcastMiniMobPlayer = false;
  maxLengthToHide = 5;
  mobileViewallExpand = false;
  mobScreenEpisodePlayTrigger = false;
  queuelistChoosen = 'episode';
  currentPlayingEpisodeIndex;
  closeMiniPlayerSubscribe;
  volumeIcon: string = 'branding/theme/assets/static_assets/ic-aud-pod-vol-high-on-dbg.svg';
  mutedVolumeValue;
  actionButton = false;
  showLogin = false;
  userId;
  showPlan = false;
  displayPaymentPopUp = true;
  personaLoader = false;
  audioError = false;
  podcastProgressbarInitialized = false;
  progressbarValueForPlaylist;
  currentProgressValue;
  @ViewChild('ChangePlan', {static: false}) changePlanComponent: ChangePlanComponent;
  @ViewChild('ModelPayment', {static: false}) ModelPaymentComponent: ModelPaymentComponent;


  constructor(private contentService:ContentService, public settingsService:SettingsService,
    public playContentService:PlayContentService,private categoriesService: CategoriesService,
    private baseService:BaseService, private subCategoryService:SubCategoryService, private uikitService:UikitService,
    private storageService:StorageService, public configService:ConfigurationService, public wishlistService:WishlistService, 
    private homeService:HomeService, private analyticsService:InhouseAnalyticsService){
    this.closeMiniPlayerSubscribe = this.playContentService.closeMiniPlayer.subscribe(data => data && this.closePlayer());
    this.genreCurationEnabled = this.settingsService.genreCurationEnabled;
    this.guestSubscribe =  this.baseService.guest.subscribe(data => this.guest = data);
    this.selectedContentTypeSubscribe = this.playContentService.selectedContentType.subscribe(data => this.currentSelectedType = data)
    this.currentContentCollectionSubscribe = this.playContentService.currentContentCollection.subscribe(data =>{
      this.currentCollection = data;
      this.position = this.currentCollection?.position;
    })
    this.windowWidth = window.innerWidth;
    this.userId = this.storageService.getLocalStore('u_id');
    if(this.settingsService.enableRegistration && !this.userId){
      this.actionButton = true;
      this.showLogin = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.audioPlayer){
      this.audioPlayer.nativeElement.pause();
      this.audioPlayer.nativeElement.currentTime = 0;
    }
    if(this.playlistContent.length){
      this.playlistContent = [];
      this.queueList = [];
      this.episodesList = [];
    }   
    if(changes.data.currentValue){
      this.currentContentAssetData={
        title:this.data?.title || "",
        cast:this.data?.cast || "",
        poster_square:this.data?.poster_square || "",
        genre:[],
        content_id:this.data?.content_id,
        is_audio:this.data?.is_audio,
        is_series:this.data?.is_series,
        description:'',
        wishlist_status:false
      }
      
      if((this.data?.is_audio && !this.data?.is_series)) {
        this.showPlayer = true;
        this.personaLoader = true;
        this.getContentPersona(this.data?.content_slug);  
      }
      if((this.data?.is_audio && this.data?.is_series)) {
        this.getAllEpisode(this.data?.series_slug);
        this.showPlayer = false;
        if(this.windowWidth <= 1024) {
          this.showPlayer = true;
          this.showPodcastMiniMobPlayer = false;
          this.showMobScreen = true;
        }
       if(this.windowWidth > 1024) this.openUikitDialog('#audio-playlist');
      }
      if(this.currentCollection?.component != 'audio_wishlist'){
        if((this.data?.is_audio && !this.data?.is_series)) this.getAllContents();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.windowWidth = window.innerWidth;
  }

  onTouchStart(){
    this.showMobScreen = true;
  }

  ngOnInit(): void {
    this.seekbarBaseColor = getComputedStyle(document.documentElement).getPropertyValue('--seekbar-base-color').trim();
    this.seekbarProgressColor = getComputedStyle(document.documentElement).getPropertyValue('--seekbar-progress-color').trim();
  }

  ngAfterViewInit(): void {
    let audioPlayer = this.audioPlayer.nativeElement;
    audioPlayer.addEventListener('timeupdate', () => {
      this.updateCurrentProgressbar();
    });
    audioPlayer.addEventListener('loadedmetadata', () => {
      this.updateTotalDuration();
    });
    audioPlayer.addEventListener('volumechange', () => {
      this.updateVolume()
    })
    audioPlayer.addEventListener('ended',() =>{
      this.onAudioEnded();
    });
    audioPlayer.addEventListener('error',(event) =>{
      this.onAudioError(event);
    });
    audioPlayer.addEventListener('play',()=>{
      this.onPlayerPlay()
    });
    audioPlayer.addEventListener('pause',()=>{
      this.onPlayerPause()
    });
    this.progressBarContainer.nativeElement.addEventListener('click', this.seekTo.bind(this)); // Add click listener
    this.updateVolumeIcon(this.audioPlayer.nativeElement.volume);
  }

  ngAfterViewChecked(): void {
    if(!this.podcastProgressbarInitialized && this.progressBarContainer){
      this.progressBarContainer.nativeElement.addEventListener('click', this.seekTo.bind(this));
      this.podcastProgressbarInitialized = true;
    }
  }

  loadWishlistData(skip, take, contenttype){
    const data = {skip, take, contenttype};
    this.wishlistService.getWishlist(data).subscribe((resp)=>{
      const content = resp.data.contents;
      const audioObject = content.find(data => data.key === 'audio_wishlist');
      const audioData = audioObject ? audioObject.list : null;
      const audioDataArray = audioData.map(data => data.content_id);
      this.playlistContent.forEach(item =>{
        item.wishlist_status = audioDataArray.includes(item.content_id);
      })
      this.queueList.forEach(item =>{
        item.wishlist_status = audioDataArray.includes(item.content_id);
      })
      this.currentContentAssetData.wishlist_status = audioDataArray.includes(this.currentContentAssetData.content_id);
    })
  }

  setVolume(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.audioPlayer.nativeElement.volume = inputElement.valueAsNumber;
    this.updateVolumeIcon(inputElement.valueAsNumber);
  }

  updateVolume(): void {
    if(this.windowWidth > 1024){
      const currentVolume = this.audioPlayer.nativeElement.volume;
      let volumeSlider = document.querySelector('.volume-slider') as HTMLInputElement;
      volumeSlider.value = currentVolume.toString();
      this.updateVolumeIcon(currentVolume);
    }
  }

  updateVolumeIcon(volume: number): void {
    if (volume === 0) {
      this.volumeIcon = 'branding/theme/assets/static_assets/ic-aud-pod-vol-0-on-dbg.svg';
    } else if (volume > 0 && volume <= 0.3) {
      this.volumeIcon = 'branding/theme/assets/static_assets/ic-aud-pod-vol-low-on-dbg.svg';
    } else if (volume > 0.3 && volume <= 0.7) {
      this.volumeIcon = 'branding/theme/assets/static_assets/ic-aud-pod-vol-med-on-dbg.svg';
    } else {
      this.volumeIcon = 'branding/theme/assets/static_assets/ic-aud-pod-vol-high-on-dbg.svg';
    }
  }

  muteUnmute(){
    let currentVolume = this.audioPlayer.nativeElement.volume;
    if(currentVolume != 0){
      this.mutedVolumeValue = this.audioPlayer.nativeElement.volume;
      this.audioPlayer.nativeElement.volume = 0;
    }else if(this.mutedVolumeValue) this.audioPlayer.nativeElement.volume = this.mutedVolumeValue;
  }

  seekTo(event: MouseEvent) {
    const progressBarRect = this.progressBarContainer.nativeElement.getBoundingClientRect();
    const clickPosition = event.clientX - progressBarRect.left;
    const seekTime = (clickPosition / progressBarRect.width) * this.audioPlayer.nativeElement.duration;
    this.audioPlayer.nativeElement.currentTime = seekTime;
    this.updateCurrentProgressbar(); // Update the progress bar after seeking
  }

   getContentPersona(slug){
    if(this.playlistContent.length > 0){
      let findObj = this.playlistContent.find(content => content.content_slug === slug && content.playbackurl !== '');
      if(findObj){
        this.currentPlayingContentAvailability = findObj?.availability;
        this.currentPlayingContentGeoAvailability =  findObj?.geo_available;
        if(this.currentPlayingContentGeoAvailability){
          if(this.currentPlayingContentAvailability == 1 || this.currentPlayingContentAvailability == 5 || !this.userId){
            if(this.windowWidth > 1024){
              this.actionButton = true;
              this.openUikitDialog('#audio-playlist');
            }
            if(this.windowWidth <= 1024) {
              this.actionButton = true;
              if(!this.showMobScreen) this.onTouchStart();
            }
          }else{
            this.actionButton = false;
            this.currentPlayingContentUrl = findObj.playbackurl;
            this.auidoPlayerTrigger();
          }
        }
       else{
        if(this.windowWidth > 1024){
          this.openUikitDialog('#audio-playlist');
        }
        if(this.windowWidth <= 1024) {
          if(!this.showMobScreen) this.onTouchStart();
        }
       } 
        this.personaLoader = false;
      } else  this.personaApiCall(slug)
    }else{
      this.personaApiCall(slug)
    }

  }

  scrollDown(){
    if(this.currentSelectedType == 'audio'){
      if(this.showMobScreen) this.showMobScreen = false;
    }
    if(this.currentSelectedType == 'podcast'){
      if(this.showPodcastMiniMobPlayer) this.showMobScreen = false;
      else this.closePlayer()
    }
  }

  goBack(){
    this.mobileViewallExpand = false;
  }

  async addToWishlist(data) {
    if (this.actionButton) {
        this.entitlementFunc();
    } else {
        try {
            await lastValueFrom(this.playContentService.audioAddToWishlist(data));
            this.loadWishlistData(0, 100, 'audio');
        } catch (err) {
            console.error('Error adding to wishlist:', err);
        }
    }
}


  async removeFromWishlist(data){
    const contentType = data.is_series && data.is_audio ? 'podcast' : 'audio';
    const paramsData: object = {
      req: { content_type: contentType, id: data.content_id },
    };
    try{
      const data = await lastValueFrom(this.wishlistService.removeWishlist(paramsData));
      const eventObj = {
        event_type: 'Event',
        event_name: 'Remove From Wishlist',
        event_status: 'Success',
      };
      this.analyticsService.trackUserActions(eventObj);
      if(data){
          this.homeService.updateUserContentFlag = true;
          this.homeService.updateUserContent.next(true);
          if (data.is_series) {
            this.wishlistService.removeFlagOn = true;
          }
      }
      this.loadWishlistData(0, 100, 'audio');
    }catch(err){
      const eventObj = {
        event_type: 'Event',
        event_name: 'Remove From Wishlist',
        event_status: 'Failure',
        event_description: err
      };
      this.analyticsService.trackUserActions(eventObj);
    }
  }


  addToWishlistEmit(e){
    this.addToWishlist(e.data);
  }
  removeFromWishlistEmit(e){
    this.removeFromWishlist(e.data);
  }

  personaApiCall(slug){
    this.contentService.getContentPersonData(slug).subscribe((resp) =>{
      if(resp.status_code == 200){
        this.personaApiFail = false;
        this.currentContentPersona = resp.data;
        this.currentContentAssetData.wishlist_status = this.currentContentPersona.wishlist_status;
        this.currentPlayingContentAvailability = this.currentContentPersona?.availability;
        this.currentPlayingContentGeoAvailability = this.currentContentPersona?.geo_available;
        if(this.currentPlayingContentGeoAvailability){
          if(this.currentPlayingContentAvailability == 1 ||this.currentPlayingContentAvailability == 5 || !this.userId){
            if(this.windowWidth > 1024){
              this.actionButton = true;
              this.openUikitDialog('#audio-playlist');
            }
            if(this.windowWidth <= 1024) {
              this.actionButton = true;
              if(!this.showMobScreen) this.onTouchStart();
            }
          }
          else{
            this.actionButton = false;
            this.currentPlayingContentUrl = this.currentContentPersona.playback_url;
            if(this.playlistContent.length > 0){
              this.playlistContent = this.playlistContent.map(obj => {
                if (obj.content_slug === slug) if (obj.playbackurl === '') return { ...obj, playbackurl: this.currentContentPersona.playback_url,geo_available: this.currentContentPersona.geo_available };
                return obj;
              });
              this.auidoPlayerTrigger();
            }else this.auidoPlayerTrigger();
          }
        }else{
          if(this.playlistContent.length > 0){
            this.playlistContent = this.playlistContent.map(obj => {
              if (obj.content_slug === slug) if (obj.playbackurl === '') return { ...obj, playbackurl: this.currentContentPersona.playback_url,geo_available: this.currentContentPersona.geo_available  };
              return obj;
            });
          }
          if(this.windowWidth > 1024){
            this.openUikitDialog('#audio-playlist');
          }
          if(this.windowWidth <= 1024) {
            if(!this.showMobScreen) this.onTouchStart();
          }
        }
        this.personaLoader = false;
      }
    }, (error) => {
      this.personaLoader = false;
      this.personaApiFail = true;
    })
  }

  entitlementFunc(){
    if(this.guest){
      this.closePlayer();
      this.playContentService.loginRoute('Audio', this.currentContentAssetData.content_id);
    }
    else {
      this.displayPaymentPopUp = true;
      this.showPlan = true;
      $('#open-pay-dialog').addClass('uk-open').show();
      this.clearSelectedPaymentOptions();
    }
   
  }
  
  clearSelectedPaymentOptions() {
    if (this.changePlanComponent) {
      this.changePlanComponent.step = 1;
      this.changePlanComponent.freePlanStep = 0;
      this.changePlanComponent.selectedPlan = {};
      this.changePlanComponent.displayProratedData = false;
    }
    if (this.ModelPaymentComponent) this.ModelPaymentComponent.ngOnInit();
  }

  auidoPlayerTrigger(){
    this.showPlayer = true;
    if(this.currentSelectedType == 'podcast') this.showPodcastMiniMobPlayer = true;
    this.showPodcastMiniMobPlayer = true;
    this.audioPlayer.nativeElement.src = this.currentPlayingContentUrl;
    this.audioPlayer.nativeElement.load();
    this.audioPlayer.nativeElement.play();
    this.isPlaying = true;
  }

  getAllContents(){
    const SubCatdata = {
      guest: this.guest,
      title: this.data.collection_slug,
      component: this.currentCollection.component,
      skip:0,
      take:100
    };
    this.subCategoryService.getSubCategory(SubCatdata).subscribe((data)=>{
      if(data){
        this.audioCollectionApiFail = false;
        data.contents.forEach((obj,index) =>{
          obj.playbackurl = '';
          obj.position = index;
        })
        this.playlistContent = [...data.contents];
        this.queueList = [...data.contents];
        this.playlistContent =  this.playlistContent.map((obj) =>{
          return {...obj , wishlist_status: false }
        })
        this.queueList =  this.queueList.map((obj) =>{
          return {...obj , wishlist_status: false }
        })
        if(this.position == this.playlistContent.length -1){
          if(this.audioRepeat){
            this.queueList = [...this.playlistContent].slice(0, this.position);
          }else this.queueList = [];
        }else {
          if(this.audioRepeat){
            let slicedArrayFirst = [...this.playlistContent].slice(this.position+1);
            let slicedArraySecond = [...this.playlistContent].slice(0,this.position+1);
            this.queueList =[...slicedArrayFirst, ...slicedArraySecond];
          }else this.queueList = [...this.playlistContent].slice(this.position+1);
        }
        this.loadWishlistData(0,100, 'audio');
      }
    }, (error)=> this.audioCollectionApiFail =  true)
  }

  getAllEpisode(seriesSlug){
    this.categoriesService.getSeriesContents(seriesSlug).subscribe((seriesData) =>{
      if(seriesData){
        this.personaApiFail = false;
        if(seriesData?.series?.has_season){
          seriesData?.seasons[0]?.contents.forEach((obj,index) =>{
            obj.playbackurl = '';
            obj.position = index;
          });
          this.episodesList = seriesData?.seasons[0]?.contents;
        }else{
          seriesData?.series?.series_contents.forEach((obj,index) =>{
            obj.playbackurl = '';
            obj.position = index;
          })
          this.episodesList = seriesData?.series?.series_contents;
        }
        this.playlistContent = [...this.episodesList];
        this.queueList = [...this.playlistContent];
        this.playlistContent =  this.playlistContent.map((obj) =>{
          return {...obj , wishlist_status: false }
        })
        this.queueList =  this.queueList.map((obj) =>{
          return {...obj , wishlist_status: false }
        })
        let currentSeries = seriesData?.series;
        if(this.genreCurationEnabled) this.currentContentAssetData.genre = currentSeries.genre_collections;
        else this.currentContentAssetData.genre = currentSeries.tags.split(",");
        this.currentContentAssetData.description = currentSeries?.description;
      }
    },(error)=> this.personaApiFail = true);

    if(!this.userId) this.actionButton = true;
    else this.getSeriesPersonaData(seriesSlug);
  }

  getSeriesPersonaData = async(seriesSlug)=>{
    const response:any = await this.contentService.getSeriesPersonData(seriesSlug);
    if(response?.status_code === 200){
      const data = response?.data;
      this.currentContentAssetData.wishlist_status = data.wishlist_status;
      this.currentPlayingContentAvailability = data?.availability;
      this.currentPlayingContentGeoAvailability = data?.geo_available;
      if(this.currentPlayingContentAvailability == 1 || this.currentPlayingContentAvailability == 5 || !this.userId) this.actionButton = true;
      else this.actionButton = false;
    }
  }

  audioPlayEvent(index){
    if(this.actionButton){
      this.entitlementFunc()
    }else{
      this.audioPlayer.nativeElement.pause();
      this.isPlaying = false;
      this.audioPlayer.nativeElement.currentTime = 0;
      this.personaLoader = true;
      let currentPlayingContent = this.playlistContent[this.position];
      let newPlayingSong = this.queueList[index];
      this.queueList.unshift(currentPlayingContent);
      if(this.audioRepeat) this.queueList = this.queueList.slice(index+2).concat(this.queueList.slice(0, index+1));
      else this.queueList = this.queueList.slice(index+2);
      this.currentContentAssetData.title = newPlayingSong.title;
      this.currentContentAssetData.cast = newPlayingSong.cast;
      this.currentContentAssetData.poster_square = newPlayingSong.poster_square;
      this.currentContentAssetData.is_audio = newPlayingSong.is_audio;
      this.currentContentAssetData.is_series = newPlayingSong.is_series;
      this.currentContentAssetData.content_id = newPlayingSong.content_id;
      this.currentContentAssetData.wishlist_status = newPlayingSong.wishlist_status;
      this.position = this.playlistContent.findIndex((content) => {
        return content.content_slug === newPlayingSong.content_slug;
      });
      this.getContentPersona(newPlayingSong.content_slug);
    }
  }

  episodePlayEvent(index){
    if(this.actionButton){
      this.entitlementFunc()
    }else{
      this.audioPlayer.nativeElement.pause();
      this.isPlaying = false;
      this.audioPlayer.nativeElement.currentTime = 0;
      this.personaLoader = true;
      if(this.currentSelectedType == 'podcast' && this.windowWidth <= 1024) this.currentPlayingEpisodeIndex = index;
      if(!this.mobScreenEpisodePlayTrigger && this.windowWidth <= 1024) this.mobScreenEpisodePlayTrigger = true;
      const findObject = this.playlistContent.find(obj => obj.position == index);
      this.currentPlayingEpisode = {...findObject};
      if(this.windowWidth <= 1024) this.mobScreenCurrentEpisodeTitle = findObject.title;
      this.position = this.playlistContent.findIndex((content) => {
        return content.content_slug === findObject.content_slug;
      });
      this.personaApiCall(findObject.content_slug);
    }
  }

  openUikitDialog(modelId){
    this.queueListOpen = true;
    $(modelId).addClass('uk-open').show();
    $('html').addClass('uk-modal-active-hidden');
  }

  closemodal(){
    if ($('html').hasClass('uk-modal-active-hidden')) {
      $('html').removeClass('uk-modal-active-hidden');
    }
    this.queueListOpen = false;
    if(!this.showPlayer) this.closePlayer();
  }

  audioSkipForward(seconds){
    this.audioPlayer.nativeElement.currentTime += seconds;
  }

  audioSkipBackward(seconds){
    this.audioPlayer.nativeElement.currentTime -= seconds;
  }

  updateCurrentProgressbar(){
    const currentTime = this.audioPlayer.nativeElement.currentTime;
    const duration = this.audioPlayer.nativeElement.duration;
    this.currentProgressValue = this.currentProgressPercentage;  
    if (!isNaN(duration) && duration > 0) {
      this.currentProgressPercentage = (currentTime / duration) * 100;
      this.progressBar.nativeElement.style.width = `${this.currentProgressPercentage}%`;
    }
    this.updateCurrentTime(currentTime)
  }

  formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  }

  updateCurrentTime(currentTime, ) {
    this.currentPlayingTime = this.formatTime(currentTime);
  }

  updateTotalDuration(){
    const totalDuration = this.audioPlayer.nativeElement.duration;
    this.totalPlayingTime = this.formatTime(totalDuration);
  }

  playerPlay(){
    if(!this.currentPlayingContentGeoAvailability) return;
    else if(this.actionButton){
      this.entitlementFunc()
    }else{
      this.audioPlayer.nativeElement.play();
    }
  }

  playerPause(){
    if(!this.currentPlayingContentGeoAvailability) return;
    else if(this.actionButton){
      this.entitlementFunc()
    }else{
      this.audioPlayer.nativeElement.pause();
    }
  }

  miniPlayerPlay(){
    if(this.actionButton || !this.currentPlayingContentGeoAvailability){
      if(this.windowWidth > 1024){
        this.openUikitDialog('#audio-playlist');
      }
      if(this.windowWidth <= 1024) {
        if(!this.showMobScreen) this.onTouchStart();
      }
    }else{
      this.audioPlayer.nativeElement.play();
    }
  }

  miniPlayerPause(){
    if(this.actionButton || !this.currentPlayingContentGeoAvailability){
      if(this.windowWidth > 1024){
        this.openUikitDialog('#audio-playlist');
      }
      if(this.windowWidth <= 1024) {
        if(!this.showMobScreen) this.onTouchStart();
      }
    }else{
      this.audioPlayer.nativeElement.pause();
    }
  }

  onPlayerPlay(){
    this.isPlaying = true;
  }

  onPlayerPause(){
    this.isPlaying = false;
  }

  onAudioEnded(){
    this.isPlaying = false;
    this.currentPlayingTime = 0;
    this.totalPlayingTime = 0;
    if(this.currentSelectedType == 'podcast') this.currentProgressValue = 0;
    this.progressBar.nativeElement.style.width = '0%';
    if(this.queueList.length > 0 && this.currentSelectedType == 'audio') this.nextSong();
  }

  onAudioError(event){
    if(event.type == 'error'){
    }
  }

  expandMobieViewall(){
    this.mobileViewallExpand = true;
    this.mobileAudioPodcastContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
  }

  shuffleEvent(){
    if(!this.shuffle){
      this.queueList = this.shuffleArray([...this.queueList]);
      this.shuffle = true;
    }
    else{
      if(!this.audioRepeat){
        if(this.position > 0){ 
          let slicedArrayFirst = [...this.playlistContent].slice(this.position+1);
          let slicedArraySecond = [...this.playlistContent].slice(0,this.position);
          this.queueList =[...slicedArrayFirst, ...slicedArraySecond];
        }else if(this.position == 0) this.queueList = [...this.playlistContent].slice(this.position+1);
      }else{
        if ((this.position == (this.playlistContent.length - 1))) this.queueList = [];
        else if((this.position >= 0) && (this.position != (this.playlistContent.length - 1))) this.queueList = [...this.playlistContent].slice(this.position+1);
      }
      this.shuffle = false;
    }
  }

  shuffleArray(array: any[]): any[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1)); 
      [array[i], array[j]] = [array[j], array[i]]; 
    }
    return array;
  }

  prevSong(){
    if(!this.audioRepeat && this.position == 0) return;
    this.audioPlayer.nativeElement.pause();
    this.isPlaying = false;
    this.audioPlayer.nativeElement.currentTime = 0;
    let playContent;
    let CurrentPlayingItem = this.playlistContent[this.position];
    if(this.audioRepeat){
      this.queueList.unshift(CurrentPlayingItem);
      playContent = this.queueList.pop();
    }else{
      if(this.position  > 0){
        this.queueList.unshift(CurrentPlayingItem);
        playContent = this.playlistContent[this.position - 1];
      }
    }
    this.currentContentAssetData.title = playContent.title;
    this.currentContentAssetData.cast = playContent.cast;
    this.currentContentAssetData.poster_square = playContent.poster_square;
    this.currentContentAssetData.is_audio = playContent.is_audio;
    this.currentContentAssetData.is_series = playContent.is_series;
    this.currentContentAssetData.content_id = playContent.content_id;
    this.currentContentAssetData.wishlist_status = playContent.wishlist_status;
    this.position = this.playlistContent.findIndex((content) => {
      return content.content_slug === playContent.content_slug;
    });
    this.personaLoader = true;
    this.getContentPersona(playContent.content_slug);
  }

  nextSong(){
    if(!this.audioRepeat && (this.position == (this.playlistContent.length-1))) return;
    this.audioPlayer.nativeElement.pause();
    this.isPlaying = false;
    this.audioPlayer.nativeElement.currentTime = 0;
    let nextPlayItem = this.queueList.shift();
    let CurrentPlayingItem = this.playlistContent[this.position];
    if(this.audioRepeat) this.queueList.push(CurrentPlayingItem);
    this.currentContentAssetData.title = nextPlayItem.title;
    this.currentContentAssetData.cast = nextPlayItem.cast;
    this.currentContentAssetData.poster_square = nextPlayItem.poster_square;
    this.currentContentAssetData.is_audio = nextPlayItem.is_audio;
    this.currentContentAssetData.is_series = nextPlayItem.is_series;
    this.currentContentAssetData.content_id = nextPlayItem.content_id;
    this.currentContentAssetData.wishlist_status = nextPlayItem.wishlist_status;
    this.position = this.playlistContent.findIndex((content) => {
      return content.content_slug === nextPlayItem.content_slug;
    });
    this.personaLoader = true;
    this.getContentPersona(nextPlayItem.content_slug);
  }

  repeat(){
    if(!this.audioRepeat){
      if(this.position > 0){ 
        let slicedArrayFirst = [...this.playlistContent].slice(this.position+1);
        let slicedArraySecond = [...this.playlistContent].slice(0,this.position);
        this.queueList =[...slicedArrayFirst, ...slicedArraySecond];
      }else if(this.position == 0) this.queueList = [...this.playlistContent].slice(this.position+1);
      this.audioRepeat = true;
    }else{
      if ((this.position == (this.playlistContent.length - 1))) this.queueList = [];
      else if((this.position >= 0) && (this.position != (this.playlistContent.length - 1))) this.queueList = [...this.playlistContent].slice(this.position+1);
      this.audioRepeat = false;
    }
  }

  changeChoosenTypeFunc(type){
    this.queuelistChoosen = type;
  }

  getWishlistData(){
    let wishlistdata = {
      skip:0,
      take:100,
      content_type:'audio'
    }
    this.wishlistService.getWishlist(wishlistdata).subscribe(res =>{
      if(res){
        let audioVideoData = res.data.contents;
        let audioData = audioVideoData.filter(data =>{
          if(data.key =='audio_wishlist') return data.list;
        })
        this.wishListData = audioData[0].list;
      }
    })
  }

  closePlayer(){
    this.audioPlayer.nativeElement.pause();
    this.audioPlayer.nativeElement.currentTime = 0;
    this.currentPlayingContentGeoAvailability = 1;
    if(this.queueListOpen) this.closemodal();
    this.currentContentCollectionSubscribe.unsubscribe();
    this.guestSubscribe.unsubscribe();
    this.selectedContentTypeSubscribe.unsubscribe();
    this.closeMiniPlayerSubscribe.unsubscribe();
    this.playlistContent = [];
    this.queueList = [];
    this.episodesList = [];
    this.actionButton = false;
    this.showLogin = false;
    this.showPlan = false;
    this.displayPaymentPopUp = true;
    this.playContentService.currentContentCollection.next({});
    this.playContentService.audioContentObject.next({});
    this.playContentService.showAudioPlayer.next(false);
    this.playContentService.selectedContentType.next('');
  }

}
